import { render } from "./ClientApp.vue?vue&type=template&id=281f36f6"
import script from "./ClientApp.vue?vue&type=script&lang=js"
export * from "./ClientApp.vue?vue&type=script&lang=js"

import "./ClientApp.vue?vue&type=style&index=0&id=281f36f6&lang=css"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__